import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useHistory } from 'utils/router-compat'
import { CustomTab, CustomTabs } from 'features/executive/usedStyle'
import { useExecutivePermissions } from 'features/executive/permission-store'
import {
  EXECUTIVE_TAB_ORDER,
  EXECUTIVE_TAB_PATHS,
  isExecutiveTabAllowed,
  resolveExecutiveTab,
} from 'features/executive/executive-nav.utils'
import type { ExecutiveTab } from 'api/executive/executive.types'

export default function ExecutiveTabsNav() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const history = useHistory()
  const active = resolveExecutiveTab(pathname)
  const tabs = useExecutivePermissions().executiveDashboardTabs

  const handleChange = (_: unknown, value: ExecutiveTab) => {
    if (value !== active) history.push(EXECUTIVE_TAB_PATHS[value])
  }

  const keys = EXECUTIVE_TAB_ORDER.filter((k) => isExecutiveTabAllowed(k, tabs))

  return (
    <CustomTabs value={active} onChange={handleChange} variant="scrollable" scrollButtons="auto">
      {keys.map((key) => (
        <CustomTab key={key} value={key} label={t(`EXECUTIVE.TAB.${key.toUpperCase()}`)} />
      ))}
    </CustomTabs>
  )
}
